/**
 * A classroom code as typed, in capitals: six letters, as the Unity app makes them (a project's code is six
 * digits), or the six digits the web gave classrooms before 03/11. `letters`: only the six letters.
 */
export function asClassCode(text: string, letters = false): string | null {
  const code = text.trim().toUpperCase();
  return (letters ? /^[A-Z]{6}$/ : /^([A-Z]{6}|\d{6})$/).test(code) ? code : null;
}
